import destination from '@turf/destination';
import circle from '@turf/circle';
import bearing from '@turf/bearing';
import union from '@turf/union';
import {polygon} from '@turf/helpers';

const getPointAlong = (direction, distance, point) =>
  destination(point, distance, direction + 90);

const getSimplePointAlong = (direction, distance, point) =>
  getPointAlong(direction, distance, point).geometry.coordinates;


const getAreaAlongPath = (list, spread = 100) => {
  let result = [];

  for (let i = 0; i < list.length; i++) {
    let start = list[i];
    let end = list[i + 1];

    result.push(circle(start, spread));

    if (!end) {
      break;
    }

    let direction1 = bearing(start, end);
    let direction2 = bearing(end, start);

    let corner1 = getSimplePointAlong(direction1, spread, start);

    let rectangle = [
      corner1,
      getSimplePointAlong(direction1, spread, end),
      getSimplePointAlong(direction2, spread, end),
      getSimplePointAlong(direction2, spread, start),
      corner1,
    ];

    result.push(polygon([rectangle]));
  }

  return union(...result);
};

export default getAreaAlongPath;



// WEBPACK FOOTER //
// ./src/misc/getAreaAlongPath.js